import { render, staticRenderFns } from "./FormatSetTreeFilter.vue?vue&type=template&id=12a97c0e&scoped=true&"
import script from "./FormatSetTreeFilter.vue?vue&type=script&lang=ts&"
export * from "./FormatSetTreeFilter.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSetTreeFilter.vue?vue&type=style&index=0&id=12a97c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a97c0e",
  null
  
)

export default component.exports